export default "__VITE_PUBLIC_ASSET__d3cb722b__"